import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Row, Col, Table, TabContent, TabPane, Nav, NavItem, NavLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from "reactstrap"
import { SuccessOk } from "configs/statusCode"
import ProfilePhoto from "assets/images/profile_icon.png"
import SalesRepsService from "services/Admin/SalesRepsService";
import Pagination from "components/Pagination"
import { useSelector } from "react-redux"
import AreaModal from "../AreaModal"
import { adminPrefix } from "configs/routePrefix"

function Profile(props) {
    const { id } = props.match.params;
    const salesRepsService = new SalesRepsService()
    const [salesRep, setSalesRep] = useState(null)
    const [activeTab, setActiveTab] = useState("1")
    const [appointments, setAppointments] = useState([]);
    const [activities, setActivities] = useState([]);
    const [areaModal, setAreaModal] = useState(false)
    const [shouldGetData, setShouldGetData] = useState(true)
    const [dropdownActions, setDropdownActions] = useState(false);
    const [type, setType] = useState()
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")

    useEffect(() => {
        if (id && shouldGetData) {
            salesRepsService.find(id).then(response => {
                if (response && response.status === SuccessOk) {
                    setSalesRep({ ...response.data })
                    setShouldGetData(false)
                }
            })
        }
    }, [id, shouldGetData])


    const onChangePage = (listData, type) => {
        if (type === "appointments") {
            setAppointments([...listData])
        } else {
            setActivities([...listData])
        }


    }
    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Sales Reps Profile</title>
                </MetaTags>
                <Container fluid>
                    <Row className="mb-1">
                        <Col md={6}>
                            <h4>
                                <button className="p-0 m-0 border-0 bg-light"
                                    onClick={() => {
                                        props.history.push(`${adminPrefix}/sales-rep`)
                                    }}>
                                    <i className="fa fa-arrow-left text-primary me-2"></i>
                                </button>
                                Sales Rep Profile
                                </h4>
                        </Col>
                        <Col md={6} className="d-flex flex-row-reverse">
                            <Dropdown className="dropdownWidth removebtnhover" color="light" isOpen={dropdownActions} toggle={() => setDropdownActions(c => !c)}>
                                <DropdownToggle caret>
                                    <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                                </DropdownToggle>
                                <DropdownMenu>
                                    {isExist("salesRep.edit") ?
                                        <DropdownItem onClick={() => {
                                            props.history.push(`${adminPrefix}/sales-rep/invite-sales-rep/${id}`)
                                        }}>Edit</DropdownItem> : null}
                                    {isExist("salesRep.edit") ?
                                        <DropdownItem onClick={() => {
                                            setType("Area")
                                            setAreaModal(true)
                                        }}>Assign Areas</DropdownItem> : null}
                                    {isExist("salesRep.edit") ?
                                        <DropdownItem onClick={() => {
                                            setType("Compound")
                                            setAreaModal(true)
                                        }}>Assign Compound</DropdownItem> : null}

                                </DropdownMenu>
                            </Dropdown>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5}>
                            <Row>
                                <Col md={12} >
                                    <Card style={{ minHeight: "31.5rem" }}>
                                        <CardBody>
                                            <Col md={12} >
                                                <Row>
                                                    <Col md={2}>
                                                        <img src={salesRep ?.media ?.path.length ? salesRep ?.media ?.path : ProfilePhoto} width="60" height="60" style={{ borderRadius: "50%" }} />
                                                    </Col>
                                                    <Col md={10}>
                                                        <Row>
                                                            <p className="profile_name">{salesRep ?.name.en}</p>
                                                            <p className="profile_heading_value">{salesRep ?.email}</p>
                                                        </Row>
                                                        <Row className="mt-2">
                                                            <Col md={3}>
                                                                <p className="profile_name font-size-14 text-center">Active</p>
                                                                <p className="profile_heading_value font-size-14 text-center">{salesRep ?.status ? "Active" : "Deactive"}</p>
                                                            </Col>
                                                            <Col md={5}>
                                                                <p className="profile_name font-size-14 text-center">Appointments</p>
                                                                <p className="profile_heading_value font-size-14 text-center">{salesRep ?.appointments ?.length}</p>
                                                            </Col>
                                                            <Col md={4}>
                                                                <p className="profile_name font-size-14  text-center">Activities</p>
                                                                <p className="profile_heading_value font-size-14 text-center">{salesRep ?.activities ?.length}</p>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={12}  >
                                                        <hr className="m-0 p-0" />
                                                        <Row className="my-2">
                                                            <Col md={5} className="profile_name font-size-13 fw-bold">Full Name :</Col>
                                                            <Col md={7} className="profile_heading_value font-size-13">{salesRep ?.name.en}</Col>
                                                        </Row>
                                                        <hr className="m-0 p-0" />
                                                        <Row className="my-2">
                                                            <Col md={5} className="profile_name font-size-13 fw-bold">Mobile :</Col>
                                                            <Col md={7} className="profile_heading_value font-size-13">{salesRep ?.phone}</Col>
                                                        </Row>
                                                        <hr className="m-0 p-0" />
                                                        <Row className="my-2">
                                                            <Col md={5} className="profile_name font-size-13 fw-bold">E-mail :</Col>
                                                            <Col md={7} className="profile_heading_value font-size-13"> {salesRep ?.email}</Col>
                                                        </Row>
                                                        <hr className="m-0 p-0" />
                                                        <Row className="my-2">
                                                            <Col md={5} className="profile_name font-size-13 fw-bold">Location :</Col>
                                                            <Col md={7} className="profile_heading_value font-size-13">
                                                                {salesRep ?.areas?.map((item, index) => {
                                                                    return (
                                                                        <span key={index}>{item?.name?.en}{index < salesRep ?.areas.length - 1 ? ", " : ""}</span>
                                                                    )
                                                                })}
                                                            </Col>
                                                        </Row>
                                                        <hr className="m-0 p-0" />
                                                        <Row className="my-2">
                                                            <Col md={5} className="profile_name font-size-13 fw-bold">Compounds :</Col>
                                                            <Col md={7} className="profile_heading_value font-size-13">
                                                                {salesRep ?.compounds?.map((item, index) => {
                                                                    return (
                                                                        <span key={index}>{item?.name?.en}{index < salesRep ?.compounds.length - 1 ? ", " : ""}</span>
                                                                    )
                                                                })}
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={7}>
                            <Row>
                                <Col md={6}>
                                    <Card>
                                        <CardBody className="p-3">
                                            <Row>
                                                <Col md={9}>
                                                    <p className="font-size-13 m-0 font-size-13" style={{ color: "#74788d", fontWeight: 500 }}>Completed Leads</p>
                                                    <p className="font-size-16 m-0 font-size-13" style={{ color: "#495057", fontWeight: 500 }}>{salesRep ?.completed_leads ?.length}</p>
                                                </Col>
                                                <Col md={3}  >
                                                    <div className="d-flex justify-content-center align-items-center" style={{ height: "50px", width: "50px", background: "#667ce8", borderRadius: "25px" }}>
                                                        <i className="far fa-check-circle fa-2x text-white"></i>
                                                    </div>                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col md={6}>
                                    <Card>
                                        <CardBody className="p-3">
                                            <Row>
                                                <Col md={9}>
                                                    <p className="font-size-13 m-0 font-size-13" style={{ color: "#74788d", fontWeight: 500 }}>Pending Leads</p>
                                                    <p className="font-size-16 m-0 font-size-13" style={{ color: "#495057", fontWeight: 500 }}>{salesRep ?.pending_leads ?.length}</p>

                                                </Col>

                                                <Col md={3}  >
                                                    <div className="d-flex justify-content-center align-items-center" style={{ height: "50px", width: "50px", background: "#667ce8", borderRadius: "25px" }}>
                                                        <i className="far fa-check-circle fa-2x text-white"></i>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col md={12} >
                                    <Card >
                                        <CardBody>
                                            <Row>
                                                <Nav tabs className="mb-1">
                                                    <NavItem>
                                                        <NavLink
                                                            className="fw-bold"
                                                            style={{ border: "none", borderBottom: activeTab === "1" ? "3px solid blue" : "none" }}
                                                            onClick={() => setActiveTab('1')}
                                                        >
                                                            Appointments
                                            </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink
                                                            className="fw-bold"
                                                            style={{ border: "none", borderBottom: activeTab === "2" ? "3px solid blue" : "none" }}
                                                            onClick={() => setActiveTab('2')}
                                                        >
                                                            Activities
                                               </NavLink>
                                                    </NavItem>
                                                </Nav>
                                                <TabContent activeTab={activeTab}>
                                                    <TabPane tabId="1">
                                                        <div className="table-responsive" style={{ minHeight: "19.8rem !important" }}>
                                                            <Table>
                                                                <thead>
                                                                    <tr className="bgHeaderTable">
                                                                        <th className="font-size-14 ">Date</th>
                                                                        <th className="font-size-14 ">Title</th>
                                                                        <th className="font-size-14 ">Activity Type</th>
                                                                        <th className="font-size-14 ">Status</th>
                                                                        <th className="font-size-14 ">Description</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {appointments ?.length !== 0 ? appointments ?.map((item, index) => {
                                                                        return (
                                                                            <tr key={index}>
                                                                                <th className="font-size-14 ">{item?.date}</th>
                                                                                <th className="font-size-14 ">{item?.title}</th>
                                                                                <th className="font-size-14 ">{item?.type}{item?.type === "visit" ?
                                                                                    <div>
                                                                                        <br />Locaion : {item?.location}
                                                                                    </div>
                                                                                    : null}
                                                                                </th>
                                                                                <th className="font-size-14 "><Badge
                                                                                    className="mx-1 font-size-14  m-0 text-white p-1"
                                                                                    style={{ background: getBackGround(item?.status) }}
                                                                                >
                                                                                    {item?.status}
                                                                                </Badge></th>
                                                                                <th className="font-size-14 ">{item?.description}</th>

                                                                            </tr>
                                                                        )
                                                                    }) : null}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </TabPane>
                                                </TabContent>
                                                <TabContent activeTab={activeTab}>
                                                    <TabPane tabId="2">
                                                        <div className="table-responsive" style={{ minHeight: "19.8rem !important" }}>
                                                            <Table>
                                                                <thead>
                                                                    <tr className="bgHeaderTable">
                                                                        <th className="font-size-14 ">Date</th>
                                                                        <th className="font-size-14 ">Title</th>
                                                                        <th className="font-size-14 ">Activity Type</th>
                                                                        <th className="font-size-14 ">Status</th>
                                                                        <th className="font-size-14 ">Description</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {activities ?.length !== 0 ? activities ?.map((item, index) => {
                                                                        return (
                                                                            <tr key={index} >
                                                                                <th className="font-size-14 ">{item?.date}</th>
                                                                                <th className="font-size-14 ">{item?.title}</th>
                                                                                <th className="font-size-14 ">{item?.activity_type}{item?.activity_type === "Visit" ?
                                                                                    <div>
                                                                                        <br />Locaion : {item?.location}
                                                                                    </div>
                                                                                    : null}
                                                                                </th>
                                                                                <th className="font-size-14 ">{item?.status}</th>
                                                                                <th className="font-size-14 ">{item?.description}</th>

                                                                            </tr>
                                                                        )
                                                                    }) : null}
                                                                </tbody>
                                                            </Table>
                                                        </div>

                                                    </TabPane>
                                                </TabContent>
                                            </Row>

                                        </CardBody>
                                    </Card>
                                    {activeTab === "1" ? salesRep ?.appointments ?.length ?
                                        <Row className="d-flex justify-content-end">
                                            <Pagination items={salesRep ?.appointments} onChangePage={(list) => onChangePage(list, "appointments")} />
                                        </Row> : null : null
                                      }
                                    {activeTab === "2" ? salesRep ?.activities ?.length ?
                                        <Row className="d-flex justify-content-end">
                                            <Pagination items={salesRep ?.activities} onChangePage={(list) => onChangePage(list, "activities")} />
                                        </Row> : null : null
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {areaModal ? <AreaModal
                        modal={areaModal}
                        setShouldGetData={setShouldGetData}
                        type={type}
                        toggle={() => setAreaModal(!areaModal)}
                        id={salesRep ?.id}
                        salesRep={{ label: salesRep ?.name ?.en, value: salesRep ?.id }}
                    /> : null}
                </Container>
            </div>
        </React.Fragment >
    );
}

const getBackGround = (status) => {
    return status === "Done" ? "#34e38f"
        : status === "Upcoming" ? "#50a5f1" : "#74788d"
}

export default Profile;
